import ContactCrazy from "./ContactCrazy"

export default ContactCrazy